globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
var mapDefaultArgs = {
  showRestaurant: true,
  lat: 45.116177,
  lon: 7.742615,
  approximateLat: 45.116177,
  approximateLon: 7.742615
};
export { mapDefaultArgs };